<template>
  <div>
    <table class="export_table" id="export_table">
      <tr>
        <th>No</th>
        <th>이름</th>
        <th>아이디</th>
        <th>본부</th>
        <th>소속</th>
        <th>소속팀</th>
        <th>직급</th>
        <th>담당업무</th>
        <th>전화번호</th>
        <th>상태</th>
      </tr>
      <tr :key="'excel_exp_' + index" v-for="(item, index) in list">
        <td>{{index + 1}}</td>
        <td>{{item.userName}}</td>
        <td>{{item.userId}}</td>
        <td>
          <template v-if="item.officeCode != null">
            <template v-for="ofc1 in ofc1List" v-if="ofc1.codeValue === (item.officeCode.length === 5 ? item.officeCode : item.officeCode.substring(0, 5))">{{ofc1.codeName}}</template>
          </template>
          <template v-else>-</template>
        </td>
        <td>
          <template v-if="item.affiliateCode != null">
            <template v-for="afc in afcList" v-if="afc.codeValue === item.affiliateCode">{{afc.codeName}}</template>
          </template>
          <template v-else>-</template>
        </td>
        <td>{{item.teamName}}</td>
        <td>{{item.jobRank}}</td>
        <td>
          <template v-if="item.chargeCode != null">
            <template v-for="rwk in rwkList" v-if="rwk.codeValue === item.chargeCode">{{rwk.codeName}}</template>
          </template>
          <template v-else>-</template>
        </td>
        <td>{{item.mobileNum}}&#8203;</td>
        <td>
          <template v-if="item.useState != null">
            <template v-if="item.useState === 0">신청</template>
            <template v-if="item.useState === 1">승인</template>
            <template v-if="item.useState === 2">거부</template>
            <template v-if="item.useState === 3">이용 정지</template>
          </template>
          <template v-else>-</template>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import xlsx from 'xlsx/xlsx'
import common from '../../script/common'

export default {
  props: ['exportData', 'filter'],
  data () {
    return {
      afcList: [],
      ofcList: [],
      ofc1List: [],
      rwkList: [],
      list: this.exportData,
      localFilter: this.filter
    }
  },
  mounted () {
    common.getSession(response => {
      if (response.data.resultCode === 1 && response.data.result != null && response.data.result.userPid != null && response.data.result.userRole != null) {
        let intervalCnt = 0
        let interval = setInterval(() => {
          if (common.checkValidateData('session', sessionStorage.getItem('afcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('ofcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('rwkList'))) {
            clearInterval(interval)
            this.afcList = JSON.parse(sessionStorage.getItem('afcList'))
            this.ofcList = JSON.parse(sessionStorage.getItem('ofcList'))
            this.ofc1List = this.getOfc1List()
            this.rwkList = JSON.parse(sessionStorage.getItem('rwkList'))
            this.$emit('prepared')
          } else if (intervalCnt > 10) {
            clearInterval(interval)
            common.amsAlert('retry', '필수 데이터를 불러오지 못했습니다.')
          } else {
            intervalCnt++
          }
        }, 200)
      } else {
        common.amsAlert('general', '로그아웃 되었습니다.\n다시 로그인해주세요.')
        this.$router.replace('/Login')
      }
    })
  },
  watch: {
    exportData (newVal) {
      this.list = newVal.list
    }
  },
  methods: {
    getOfc1List () {
      return this.ofcList.filter(item => { return item.codeLevel === 0 })
    },
    download () {
      let mainData = xlsx.utils.table_to_sheet(document.getElementById('export_table'))
      let workBook = xlsx.utils.book_new()
      xlsx.utils.book_append_sheet(workBook, mainData, 'sheet1')
      let strToday = common.getFormattedDate(Date.now()).replaceAll('-', '')
      xlsx.writeFile(workBook, '사용자현황_' + strToday + '_' + this.localFilter.page + '.xlsx')
    }
  }
}
</script>

<style scoped>
.export_table {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/excel/ExcelDownloadMember.vue